import React, { useState, useEffect } from "react";
import Modal from 'react-modal';
import { LoadingSpinner } from '../../../../components/Loader/Loader';
import http, { URL_S3 } from '../../../../config/BaseUrl';

const customStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgb(0 0 0 / 80%)',
    zIndex:100,
    width:'700x',
    height:'500x',
  },
  content: {
    position: 'relative',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width:'700px',
    height:'500',
    overflow: 'hidden'
  },
  closeBtn:{
    position: 'absolute',
    top:0,
    right:'-1%',
    background:'transparent',
    border:'none',
    color:'red'
  }
};

const GifCustomFrameModal = ({ isOpen, closeModal, eventId, setCustomFrame, selectedFrame }) => {
  const [loading, setLoading] = useState(false)
  const [fileError, setFileError] = useState(false)
  const [currentFrameRatio, setCurrentFrameRatio] = useState({width: 0, height: 0})
  const [frameSize, setFrameSize] = useState({width: 0, height: 0})
  const [image, setImage] = useState({src: '', width: 0, height: 0})

  const backgroundStyle = {
    width: '100%',
    height: '500px',
    backgroundColor: '#f1f1f1',
    position: 'relative'
  }

  useEffect(()=> {
    if (selectedFrame) {
      let imgProps = new Image()

      imgProps.onload = (img) => {
        
        let w = imgProps.width;
        let h = imgProps.height;

        let newImageWidth = (w / h) * 500
        let newImageHeight = (h / w) * 628

        setFrameSize({width: newImageWidth, height: newImageHeight})
        setCurrentFrameRatio({width: w, height: h})

        
      }

      imgProps.src = `${URL_S3}image/gif/preview_image/${selectedFrame.image}`;

    }
  }, [selectedFrame])

  useEffect(()=> {
    if (currentFrameRatio.width > 0) {
      if (selectedFrame.custom_frame) {
        imageRatioGet(`${URL_S3}image/gif/frame_image/custom_frame/${selectedFrame.custom_frame.frame}`)
      }
    }
  }, [currentFrameRatio, selectedFrame])

  const uploadCustomFrame = (event) => {
    const fileReader = new FileReader();

    fileReader.onload = (e) => {
      let imgProps = new Image()

      imgProps.onload = () => {
        
        let w = imgProps.width;
        let h = imgProps.height;

        if (w <= currentFrameRatio.width && h <= currentFrameRatio.height) {
          setFileError(false)
          let newImageWidth = (w / h) * (frameSize.height > 500 ? 500 : frameSize.height)
          let newImageHeight = (h / w) * (frameSize.width > 628 ? 628 : frameSize.width)

          setImage({
            src: e.target.result,
            width: newImageWidth,
            height: newImageHeight
          })
        }
        else{
          setImage({src: '', width: 0, height: 0})
          event.target.value = ""
          setFileError(true)
        }
        
      }

      imgProps.src = e.target.result;
    }

    fileReader.readAsDataURL(event.target.files[0])
  }

  const imageRatioGet = (imgSrc, event=null) => {
    let imgProps = new Image()

    imgProps.onload = () => {
      
      let w = imgProps.width;
      let h = imgProps.height;

      if (w <= currentFrameRatio.width && h <= currentFrameRatio.height) {
        setFileError(false)
        let newImageWidth = (w / h) * (frameSize.height > 500 ? 500 : frameSize.height)
        let newImageHeight = (h / w) * (frameSize.width > 628 ? 628 : frameSize.width)

        setImage({
          src: imgSrc,
          width: newImageWidth,
          height: newImageHeight
        })
      }
      else{
        setImage({src: '', width: 0, height: 0})
        if (event) {
          event.target.value = ""
          setFileError(true)
        }
      }
      
    }

    imgProps.src = imgSrc;
  }


  const updateCustomFrame = () => {
    if (image.src) {
      setLoading(true)
      const data = {
        customImage: image.src,
        event_id: eventId,
        frame_id: selectedFrame.id
      }
      http.post("create-gif-custom-frame", data)
        .then(res=> {
          setLoading(false)
          setCustomFrame(res.data.custom_frame, selectedFrame.id)
          closeModal()
        })
        .catch(err=> {
          console.log(err)
        })
    }
  }

  const removeCustomFrame = () => {
    if (selectedFrame.custom_frame) {
      setLoading(true)
      const data = {
        id: selectedFrame?.custom_frame?.id
      }
      http.post("removed-gif-custom-frame", data)
        .then(res=> {
          setLoading(false)
          setCustomFrame(null, selectedFrame.id)
          setImage({src: '', width: 0, height: 0})
          closeModal()
        })
        .catch(err=> {
          // setCustomFrame(null, selectedFrame.id)
          // setImage({src: '', width: 0, height: 0})
          console.log(err)
        })
      
    }
  }


  return (
    <Modal
      isOpen={isOpen}
      style={customStyles}
      contentLabel="Gif"
    >
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <form onSubmit={e => e.preventDefault()}>
              <div className="mb-2 border-bottom">
                <h3>Custom Frame Upload</h3>
              </div>
              <div className='form-group mb-4'>
                <label>Custom Frame Image <span className='font-weight-bold small' style={{color: 'black'}}>Frame Size (width: {currentFrameRatio.width}px - height: {currentFrameRatio.height}px)</span></label>
                <input type={'file'} className="form-control" onChange={uploadCustomFrame} />
                {
                  fileError &&
                  <span style={{color: 'red'}}>Please upload file between the frame size</span>
                }
              </div>
              <div className='custom-frame' style={backgroundStyle}>
                
                <img className='main' style={{position: 'absolute', top: 0, left: '50%', transform: 'translate(-50%)', height: '100%', width: `${frameSize.width}px`, maxWidth: '100%', maxHeight: '100%', objectFit: 'contain'}} src={`${URL_S3}image/gif/preview_image/${selectedFrame.image}`} alt="frame" />
                {
                  image.src &&
                  <img src={image.src} style={{position: 'absolute', top: 0, left: '50%', transform: 'translate(-50%)', height: '100%', width: `${frameSize.width}px`, maxWidth: '100%', maxHeight: '100%', objectFit: 'contain'}} alt="preview" />
                }
              </div>

              <div className="pt-4 d-flex justify-content-end border-top">
                {
                  selectedFrame.custom_frame && 
                    <button type="button" className="btn btn-danger mr-2 cursor-pointer" disabled={loading} onClick={removeCustomFrame}>
                      {
                        loading ? <LoadingSpinner color="text-white" className="spinner-grow-sm" /> : "Remove Custom Frame"
                      }
                    </button>

                }
                <button type="button" className="mr-2 btn btn-primary" onClick={() => closeModal(false) } > Cancel </button>
                {
                  loading ?
                  <button className="float-right px-3 mr-2 btn btn-secondary radius-10" disabled>
                    <LoadingSpinner color="text-white" className="spinner-grow-sm" />
                  </button>
                  :
                  <button type="button" className="btn btn-primary" onClick={updateCustomFrame}>
                    Upload Frame
                  </button>
                }
              </div>
            </form>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default GifCustomFrameModal;